'use client';

import NoData from '@/components/common/no-data/NoData';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import useGetOrganizationCustomer from '@/hooks/queries/organization/useGetOrganizationCustomer';
import useMixPanel from '@/hooks/useMixPanel';
import { Plus } from 'lucide-react';
import Link from 'next/link';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import type { I18nNamespaces } from '../../../../@types/i18next';

const PurchasesButton: React.FC<{
  i18nNamespaces: (keyof I18nNamespaces)[];
}> = ({ i18nNamespaces }) => {
  const { t } = useTranslation(i18nNamespaces);
  const {
    data: organizations,
    isError,
    isLoading
  } = useGetOrganizationCustomer();
  const Mixpanel = useMixPanel();

  if (isError) {
    return <NoData />;
  }

  if (isLoading) {
    return (
      <>
        <Skeleton className="w-full h-10" />
        <Skeleton className="w-full h-12 mt-10" />
      </>
    );
  }

  if (!organizations?.length) {
    return <NoData />;
  }

  return (
    <>
      <h3 className="font-bold">{t('MyPurchases')}</h3>
      {organizations.map((organization) => {
        return (
          <Link
            href={`/${organization.code}/new-booking`}
            passHref
            key={organization.id}
          >
            <Button
              onClick={() =>
                Mixpanel.track('press buy again button', {
                  screen: 'Bookings',
                  organizationName: organization.code
                })
              }
              className="gap-4 mt-10 h-auto"
              variant={'ghost'}
            >
              <div className="flex flex-row justify-center items-center rounded-full w-8 h-8 bg-primary">
                <Plus color="white" />
              </div>
              <p className="font-bold">
                {t('buybackfrom') + ' ' + organization.name}
              </p>
            </Button>
          </Link>
        );
      })}
    </>
  );
};

export default PurchasesButton;
